function aPage(pageName) {
    return analytics.page('webapp', pageName, {}, {
        context: { ip: '0.0.0.0' },
    });
}
export class PageVisit {
    earn() {
        aPage('earn');
    }
    trade() {
        aPage('trade');
    }
    withdraw() {
        aPage('withdraw');
    }
    deposit() {
        aPage('deposit');
    }
}
//# sourceMappingURL=a-page.js.map